import React from 'react';
import { StyleSheet, useStyles } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import EmailSVG from './icons/v2Email.svg';
import PhoneSVG from './icons/v2Phone.svg';

const defaultStyles = StyleSheet({
  container: {
    display: 'flex',
    flexDirection: 'row',
    // Padding between items
    '> *': {
      paddingLeft: 16,
      paddingRight: 16,
      // Extra padding on last item to add even spacing between icon & hamburger button
      ':last-child': {
        paddingRight: 32
      }
    }
  },
  item: {
    fontSize: 14
  },
  email: {
    width: 22,
    height: 18
  },
  phone: {
    width: 22,
    height: 22
  },
  link: {
    display: 'flex',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'none',
      opacity: '0.7'
    }
  },
  mobileNav: {
    display: 'none',
    '@media(max-width: 1024px)': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      flex: '1'
    }
  },
  mobileContacts: {
    '@media(max-width: 320px)': {
      display: 'none'
    }
  }
});

interface Props {
  email: string;
  phone: string;
  itemColor: string;
}
export function MobileContacts({ email, phone, itemColor }: Props) {
  const s = useStyles(defaultStyles);
  const itemStyle = {
    ...s.with('item')({
      color: itemColor,
      fill: itemColor,
      stroke: itemColor,
      strokeWidth: 0,
      fontWeight: 700
    })
  };

  return (
    <div {...s('mobileNav')}>
      <div {...s('mobileContacts')}>
        {(email || phone) && (
          <Box {...s('container')}>
            {phone && (
              <a {...s('link')} href={`tel:${phone}`}>
                <Box {...itemStyle} flex={1} alignItems={'center'}>
                  <Box alignItems={'center'}>
                    <PhoneSVG {...s('phone')} />
                  </Box>
                </Box>
              </a>
            )}
            {email && (
              <a {...s('link')} href={`mailto:${email}`}>
                <Box {...itemStyle} flex={1} alignItems={'center'}>
                  <Box alignItems={'center'}>
                    <EmailSVG {...s('email')} />
                  </Box>
                </Box>
              </a>
            )}
          </Box>
        )}
      </div>
    </div>
  );
}
